function updateMinimumOrderUI(cartLike, scope = document) {
  const containers = scope.querySelectorAll('[data-min-order-cents]');
  if (!containers.length) return;

  // ✅ Supports multiple Dawn payload shapes
  const totalCents = Number(
    cartLike?.total_price ??
    cartLike?.cart?.total_price ??
    cartLike?.cartData?.total_price ??
    0
  );

  containers.forEach((container) => {
    const minOrderCents = Number(container.dataset.minOrderCents || 0);
    if (!minOrderCents) return;

    const notice = container.querySelector('[data-minimum-notice]');
    const noticeText = container.querySelector('[data-minimum-text]');
    const checkoutBtn = container.querySelector('[data-checkout-button]');

    if (!notice || !noticeText || !checkoutBtn) return;

    const belowMin = totalCents < minOrderCents;
    const missingCents = Math.max(minOrderCents - totalCents, 0);

    if (belowMin) {
      notice.style.display = 'block';
     noticeText.innerHTML =
      `${window.cartTranslations.minimumLabel} ${formatMoney(minOrderCents)}. ` +
      `${window.cartTranslations.minimumPrefix} ` +
      `<strong>${formatMoney(missingCents)}</strong> ` +
      `${window.cartTranslations.minimumSuffix}`;
      checkoutBtn.setAttribute('disabled', 'disabled');
    } else {
      notice.style.display = 'none';
      noticeText.innerHTML = '';
      checkoutBtn.removeAttribute('disabled');
    }
  });
}


function formatMoney(cents) {
  if (window.Shopify && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents);
  }
    return new Intl.NumberFormat('de-AT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }).format(cents / 100).replace(/\s/g, '');;
}


class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

renderContents(parsedState) {
  this.cartItemKey = parsedState.key;

  this.getSectionsToRender().forEach((section) => {
    document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
      parsedState.sections[section.id],
      section.selector
    );
  });

  // Open immediately (do not wait for fetch)
  if (this.header) this.header.reveal();
  this.open();

  // Now fetch the real cart totals and update the minimum UI
  fetch(`${routes.cart_url}.js`)
    .then((r) => r.json())
    .then((cart) => updateMinimumOrderUI(cart, document))
    .catch(() => {});
}



  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
